import React from 'react';
import { useAtomValue } from 'jotai';
import type { TaskHeaderProps } from '../../../../common/task-header/task-header';
import TaskHeader from '../../../../common/task-header/task-header';
import { TASK_MODE } from '../../../../common/task-state/constants';
import useTaskStateStore from '../../../../common/task-state/providers/hooks/useTaskStateStore';
import { imageQuadrantValidationConfigAtom } from '../../atoms/image-quadrant-validation-atoms';
import { isVideoLabelingM4EnabledAtom } from '../../atoms/m4-atoms';
import { qaEngineAtom } from '../../atoms/qa-engine-atom';
import { remainingItemsCountAtom } from '../../atoms/side-panel-atoms';
import { useOpenRemainingItemsDrawer } from '../remaining-items/remaining-items-config';
type Props = TaskHeaderProps;
export const LabelingTaskHeader = ({
  ...props
}: Props) => {
  const remainingItemsCount = useAtomValue(remainingItemsCountAtom);
  const ruleEngine = useAtomValue(qaEngineAtom);
  const isM4Enabled = useAtomValue(isVideoLabelingM4EnabledAtom);
  const imageQuadrantValidationRemainingItemsConfig = useAtomValue(imageQuadrantValidationConfigAtom);
  const {
    hasRequiredTaskMode
  } = useTaskStateStore();
  const shouldShowRemainingItems = !hasRequiredTaskMode(TASK_MODE.REVIEW) || Boolean(ruleEngine) || Boolean(imageQuadrantValidationRemainingItemsConfig?.isEnabled);
  const shouldBypassRemainingItemsFeatureFlag = Boolean(ruleEngine) || Boolean(imageQuadrantValidationRemainingItemsConfig?.isEnabled) || isM4Enabled;
  const {
    openRemainingItemsDrawer
  } = useOpenRemainingItemsDrawer();
  return <TaskHeader {...props} remainingItemsCount={remainingItemsCount} shouldShowRemainingItems={shouldShowRemainingItems} bypassRemainingItemsFeatureFlag={shouldBypassRemainingItemsFeatureFlag} onRemainingItemsClick={openRemainingItemsDrawer} />;
};